import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import {
  BusquedaCentroTrabajoDialogComponent,
  BusquedaProductoDialogComponent,
  InformacionEmpresaListadoBaseComponent
} from './informacion-empresa-listado-base.component';
import { InformacionEmpresaProg } from 'src/app/domain/model/informacion-empresa/informacion-empresa-oc';
import { InformacionEmpresaRepository } from 'src/app/domain/service/informacion-empresa/informacion-empresa-repository';
import { inject } from '@angular/core';

@Component({
  selector: 'app-informacion-empresa-citas-programadas',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    PaginatorModule,
    TableModule,
    TooltipModule,
    BusquedaProductoDialogComponent,
    BusquedaCentroTrabajoDialogComponent
  ],
  styleUrls: ['../shared/styles/grid-table.styles.scss'],
  template: `
    <div class="p-3 sm:p-6 max-w-6xl mx-auto">
      <div class="mb-4 flex items-center justify-between gap-2 flex-wrap">
        <div>
          <span class="text-sm text-gray-600 mb-2 flex items-center gap-2"
            >Información Empresa >><b> Citas Programadas</b></span
          >
          <h1 class="text-xl sm:text-2xl font-bold text-gray-800 dark:text-gray-100">
            Citas Programadas
          </h1>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            Consulta de citas programadas asociadas a la empresa.
          </p>
        </div>
        <a routerLink="/informacion-empresa" [queryParams]="queryParamsRegreso">
          <button
            pButton
            label="Regresar"
            icon="pi pi-arrow-left"
            severity="secondary"
            class="p-button-outlined"
          ></button>
        </a>
      </div>

      <div
        class="rounded-lg border border-green-200 bg-green-100 p-4 text-green-900 mb-4"
      >
        <div class="font-semibold mb-2">Contexto de consulta</div>
        <div class="text-sm grid grid-cols-1 gap-2">
          <div class="rounded px-3 py-2 border border-green-100">
            <span class="font-medium">Cliente seleccionado:</span>
            <span class="ml-2">{{ nombreCliente() }}</span>
          </div>
          <div class="rounded px-3 py-2 border border-green-100">
            <span class="font-medium">Consultor seleccionado:</span>
            <span class="ml-2">{{ nombreConsultor() }}</span>
          </div>
        </div>
      </div>

      <div
        class="border border-gray-200 dark:border-gray-700 rounded p-4 mb-4 bg-gray-50 dark:bg-gray-800"
      >
        <div class="font-medium text-gray-700 dark:text-gray-200 mb-3 text-sm">
          Filtros
        </div>

        <div class="grid grid-cols-1 gap-3">
          <div>
            <label
              for="filtroAno"
              class="block text-sm text-gray-600 dark:text-gray-300 mb-1"
            >
              Año <span class="text-red-500">*</span>
            </label>
            <input
              id="filtroAno"
              pInputText
              [(ngModel)]="filtroAno"
              maxlength="4"
              class="w-full"
              placeholder="Ej: 2026"
              (input)="onAnoInput($event)"
            />
          </div>

          <div>
            <label
              for="filtroProducto"
              class="block text-sm text-gray-600 dark:text-gray-300 mb-1"
            >
              Producto
            </label>
            <div class="flex items-center gap-2 min-w-0 ">
              <input
                id="filtroProducto"
                pInputText
                [value]="productoSeleccionadoLabel()"
                class="flex-1 min-w-0"
                readonly
              />
              <button
                pButton
                icon="pi pi-search"
                class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                severity="primary"
                size="small"
                pTooltip="Buscar producto"
                tooltipPosition="left"
                (click)="abrirBusquedaProducto()"
              >
                <span class="sr-only">Buscar producto</span>
              </button>
              @if (productoSeleccionado()) {
                <button
                  type="button"
                  pButton
                  icon="pi pi-times"
                  class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                  severity="danger"
                  size="small"
                  pTooltip="Limpiar producto"
                  tooltipPosition="left"
                  (click)="limpiarProducto()"
                >
                  <span class="sr-only">Limpiar producto</span>
                </button>
              }
            </div>
          </div>

          <div>
            <label
              for="filtroOficina"
              class="block text-sm text-gray-600 dark:text-gray-300 mb-1"
            >
              Oficina <span class="text-red-500">*</span>
            </label>
            <p-dropdown
              inputId="filtroOficina"
              [options]="oficinas()"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="filtroOficina"
              [filter]="true"
              [showClear]="false"
              [style]="{ width: '100%' }"
              appendTo="body"
            ></p-dropdown>
          </div>

          <div>
            <label
              for="filtroCentroTrabajo"
              class="block text-sm text-gray-600 dark:text-gray-300 mb-1"
            >
              Centro de Trabajo
            </label>
            <div class="flex items-center gap-2 min-w-0 ">
              <input
                id="filtroCentroTrabajo"
                pInputText
                [value]="centroTrabajoSeleccionadoLabel()"
                class="flex-1 min-w-0"
                readonly
              />
              <button
                pButton
                icon="pi pi-search"
                class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                severity="primary"
                size="small"
                pTooltip="Buscar centro de trabajo"
                tooltipPosition="left"
                (click)="abrirBusquedaCentroTrabajo()"
              >
                <span class="sr-only">Buscar centro de trabajo</span>
              </button>
              @if (centroTrabajoSeleccionado()) {
                <button
                  type="button"
                  pButton
                  icon="pi pi-times"
                  class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                  severity="danger"
                  size="small"
                  pTooltip="Limpiar centro de trabajo"
                  tooltipPosition="left"
                  (click)="limpiarCentroTrabajo()"
                >
                  <span class="sr-only">Limpiar centro de trabajo</span>
                </button>
              }
            </div>
          </div>
        </div>

        <div class="mt-4 flex flex-wrap justify-end sm:justify-start gap-3 w-full">
          <button
            pButton
            label="Limpiar"
            icon="pi pi-eraser"
            class="p-button-outlined"
            severity="secondary"
            (click)="limpiarFiltros()"
          >
            <span class="sr-only">Limpiar</span>
          </button>
          <button pButton label="Buscar" icon="pi pi-search" (click)="buscar()">
            <span class="sr-only">Buscar</span>
          </button>
        </div>
      </div>

      @if (mensaje()) {
        <div class="p-3 mt-4 rounded" [ngClass]="mensajeClass()">
          {{ mensaje() }}
        </div>
      }

      <div class="mt-4">
        <div class="md:hidden space-y-3">
          @if (!loading() && items().length === 0) {
            <div class="text-center p-4 text-gray-500 border border-gray-200 dark:border-gray-700 rounded-lg">
              No se encontraron resultados para los filtros enviados.
            </div>
          }

          @for (item of items(); track $index) {
            <div class="border border-gray-200 dark:border-gray-700 rounded-lg p-3 bg-white dark:bg-gray-900">
              <div class="grid grid-cols-1 gap-2 text-sm">
                <div><span class="text-gray-500">Código Producto:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.cdproducto || '-' }}</span></div>
                <div><span class="text-gray-500">Producto:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.dsproducto || '-' }}</span></div>
                <div><span class="text-gray-500">Hrs. Prog. Campo:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.nmcantidaprogcamp ?? 0 }}</span></div>
                <div><span class="text-gray-500">Hrs. Prog. Informe:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.nmcantidaproginf ?? 0 }}</span></div>
                <div><span class="text-gray-500">Hrs. Canceladas:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.nmcantidaprogcancel ?? 0 }}</span></div>
                <div><span class="text-gray-500">Oficina:</span> <span class="text-gray-800 dark:text-gray-200">{{ item.dsoficina || '-' }}</span></div>
              </div>
              <div class="mt-3">
                <p-button label="Ver detalle" icon="pi pi-eye" severity="secondary" [outlined]="true" size="small" styleClass="w-full min-h-[44px]" (onClick)="verDetalle(item)"></p-button>
              </div>
            </div>
          }
        </div>

        <div class="hidden md:block">
        <p-table
          [resizableColumns]="true"
          columnResizeMode="expand"
          [value]="items()"
          [loading]="loading()"
          responsiveLayout="scroll"
          styleClass="tabla-informacion-empresa p-datatable-sm p-datatable-striped p-datatable-gridlines" [scrollable]="true" [tableStyle]="{ 'min-width': '72rem' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pResizableColumn>Código Producto</th>
              <th pResizableColumn>Producto</th>
              <th pResizableColumn>Hrs. Prog. Campo</th>
              <th pResizableColumn>Hrs. Prog. Informe</th>
              <th pResizableColumn>Hrs. Canceladas</th>
              <th pResizableColumn>Oficina</th>
              <th pResizableColumn>Ver Detalle</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ item.cdproducto || '-' }}</td>
              <td>{{ item.dsproducto || '-' }}</td>
              <td>{{ item.nmcantidaprogcamp ?? 0 }}</td>
              <td>{{ item.nmcantidaproginf ?? 0 }}</td>
              <td>{{ item.nmcantidaprogcancel ?? 0 }}</td>
              <td>{{ item.dsoficina || '-' }}</td>
              <td>
                <button
                  pButton
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-text p-button-sm"
                  pTooltip="Ver detalle"
                  aria-label="Ver detalle"
                  tooltipPosition="left"
                  (click)="verDetalle(item)"
                ></button>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7" class="text-center p-6 text-gray-500">
                No se encontraron resultados para los filtros enviados.
              </td>
            </tr>
          </ng-template>
        </p-table>
        </div>
      </div>

      <div class="mt-4 flex justify-end">
        <p-paginator
          [rows]="rows()"
          [first]="first()"
          [totalRecords]="totalRecords()"
          [rowsPerPageOptions]="[10, 20, 50]"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
          dropdownAppendTo="body"
          appendTo="body"
          (onPageChange)="onPageChange($event)"
        ></p-paginator>
      </div>

      @if (mostrarBuscadorProducto) {
        <app-busqueda-producto-dialog
          (onSelect)="onProductoSeleccionado($event)"
          (onClose)="cerrarBusquedaProducto()"
        ></app-busqueda-producto-dialog>
      }

      @if (mostrarBuscadorCentroTrabajo) {
        <app-busqueda-centro-trabajo-dialog
          [titulo]="'Búsqueda de Centro de Trabajo'"
          [nmconsecutivoBeneficiario]="idBeneficiario()"
          [nombreBeneficiario]="nombreCliente()"
          [cargarAlAbrir]="true"
          (onSelect)="onCentroTrabajoSeleccionado($event)"
          (onClose)="cerrarBusquedaCentroTrabajo()"
        ></app-busqueda-centro-trabajo-dialog>
      }
    </div>
  `
})
export class InformacionEmpresaCitasProgramadasComponent extends InformacionEmpresaListadoBaseComponent<InformacionEmpresaProg> {
  private readonly informacionEmpresaRepository = inject(
    InformacionEmpresaRepository
  );

  protected async consultar(first: number, rows: number): Promise<void> {
    this.loading.set(true);
    this.mensaje.set('');
    const inudesde = first + 1;
    const inuhasta = first + rows;

    try {
      const resultado =
        await this.informacionEmpresaRepository.listarCitasProgramadas({
          inuano: Number(this.filtroAno),
          inuproducto: this.productoSeleccionado()
            ? Number(this.productoSeleccionado()?.cdproducto)
            : undefined,
          inuoficina: this.filtroOficina ?? undefined,
          inubeneficiario: this.idBeneficiario() ?? undefined,
          inucentrotrabajo: this.centroTrabajoSeleccionado()?.nmconsecutivo,
          inuasesor: this.idAsesor() ?? undefined,
          inudesde,
          inuhasta
        });

      this.items.set(resultado);
      this.totalRecords.set(resultado[0]?.totalregistro ?? 0);
      if (resultado.length === 0) {
        this.mensajeTipo.set('info');
        this.mensaje.set('La consulta no retornó registros.');
      }
    } catch {
      this.items.set([]);
      this.totalRecords.set(0);
      this.mensajeTipo.set('error');
      this.mensaje.set('Error consultando Citas Programadas.');
    } finally {
      this.loading.set(false);
    }
  }

  async verDetalle(item: InformacionEmpresaProg): Promise<void> {
    await this.router.navigate(['/informacion-empresa/citas-programadas/detalle'], {
      queryParams: {
        ...this.queryParamsRegreso,
        cdproductoSeleccionado: this.toNumber(item.cdproducto ?? null) ?? undefined,
        dsproductoSeleccionado: item.dsproducto ?? undefined,
        inuoficinaSeleccionada: this.filtroOficina ?? undefined,
        anioSeleccionado: this.toNumber(this.filtroAno) ?? undefined
      }
    });
  }
}
